import { Injectable } from '@angular/core';
import { CanActivateChild, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { filter, map, take, tap } from 'rxjs/operators';
import { AppState } from 'src/app/reducers';
import { SharedActions } from 'src/app/shared/state/shared-action-types';
import { getUserPreferences } from 'src/app/shared/state/shared.selectors';
import { UserPreferences } from 'src/app/shared/models/user-preferences.model';

@Injectable({ providedIn: 'root' })
export class UserPreferencesGuard implements CanActivateChild {
  private requested = false;

  constructor(private store: Store<AppState>) {}

  canActivateChild(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> {
    return this.store.select(getUserPreferences).pipe(
      tap(p => {
        if (!p && !this.requested) {
          this.requested = true;
          this.store.dispatch(SharedActions.loadUserPreferences());
        }
      }),
      filter((p): p is UserPreferences => !!p),
      take(1),
      map(() => true)
    );
  }
}
